import { StoreDisplayGroup, SubClass, BoundShelf } from '../types/storeDisplayGroup';

// Mock Sub-Class data inherited from HQ
export const mockSubClasses: SubClass[] = [
  // Beverage Division
  {
    categoryId: 1001,
    divisionCode: 'BD',
    divisionName: 'Beverage Division',
    groupCode: 'BD_G01',
    groupName: 'Beverage Group',
    departmentCode: 'BD_D01',
    departmentName: 'Beverage Department',
    classCode: 'BD_C01',
    className: 'Carbonated Category',
    subClassCode: 'BD_SC01',
    subClassName: 'Carbonated Drinks',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  {
    categoryId: 1002,
    divisionCode: 'BD',
    divisionName: 'Beverage Division',
    groupCode: 'BD_G01',
    groupName: 'Beverage Group',
    departmentCode: 'BD_D01',
    departmentName: 'Beverage Department',
    classCode: 'BD_C02',
    className: 'Juice Category',
    subClassCode: 'BD_SC02',
    subClassName: 'Juice Drinks',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  {
    categoryId: 1003,
    divisionCode: 'BD',
    divisionName: 'Beverage Division',
    groupCode: 'BD_G01',
    groupName: 'Beverage Group',
    departmentCode: 'BD_D01',
    departmentName: 'Beverage Department',
    classCode: 'BD_C03',
    className: 'Tea Category',
    subClassCode: 'BD_SC03',
    subClassName: 'Tea Drinks',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  // Food Division
  {
    categoryId: 2001,
    divisionCode: 'FD',
    divisionName: 'Food Division',
    groupCode: 'FD_G01',
    groupName: 'Snack Food Group',
    departmentCode: 'FD_D01',
    departmentName: 'Snack Food Department',
    classCode: 'FD_C01',
    className: 'Puffed Food Category',
    subClassCode: 'FD_SC01',
    subClassName: 'Potato Chips',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  {
    categoryId: 2002,
    divisionCode: 'FD',
    divisionName: 'Food Division',
    groupCode: 'FD_G01',
    groupName: 'Snack Food Group',
    departmentCode: 'FD_D01',
    departmentName: 'Snack Food Department',
    classCode: 'FD_C02',
    className: 'Bakery Food Category',
    subClassCode: 'FD_SC02',
    subClassName: 'Biscuits',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  {
    categoryId: 2003,
    divisionCode: 'FD',
    divisionName: 'Food Division',
    groupCode: 'FD_G02',
    groupName: 'Candy Group',
    departmentCode: 'FD_D02',
    departmentName: 'Candy Department',
    classCode: 'FD_C03',
    className: 'Chocolate Category',
    subClassCode: 'FD_SC03',
    subClassName: 'Chocolate',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  // Personal Care Division
  {
    categoryId: 3001,
    divisionCode: 'PC',
    divisionName: 'Personal Care Division',
    groupCode: 'PC_G01',
    groupName: 'Beauty Group',
    departmentCode: 'PC_D01',
    departmentName: 'Beauty Department',
    classCode: 'PC_C01',
    className: 'Skincare Category',
    subClassCode: 'PC_SC01',
    subClassName: 'Face Masks',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  {
    categoryId: 3002,
    divisionCode: 'PC',
    divisionName: 'Personal Care Division',
    groupCode: 'PC_G01',
    groupName: 'Beauty Group',
    departmentCode: 'PC_D01',
    departmentName: 'Beauty Department',
    classCode: 'PC_C02',
    className: 'Makeup Category',
    subClassCode: 'PC_SC02',
    subClassName: 'Lipstick',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  },
  {
    categoryId: 3003,
    divisionCode: 'PC',
    divisionName: 'Personal Care Division',
    groupCode: 'PC_G02',
    groupName: 'Personal Care Group',
    departmentCode: 'PC_D02',
    departmentName: 'Personal Care Department',
    classCode: 'PC_C03',
    className: 'Hair Care Category',
    subClassCode: 'PC_SC03',
    subClassName: 'Shampoo',
    creatorAccount: 'admin',
    creatorName: 'Admin User',
    gmtCreate: 1640995200000,
    modifierAccount: 'admin',
    modifierName: 'Admin User',
    gmtModified: 1640995200000,
    deleted: 0
  }
];

// Mock bound shelf data
export const mockBoundShelves: { [key: string]: BoundShelf[] } = {
  'DG001': [
    {
      shelfCode: 'A-01',
      shelfName: 'A Zone Shelf 1',
      layerCount: 3
    },
    {
      shelfCode: 'A-02',
      shelfName: 'A Zone Shelf 2',
      layerCount: 3
    },
    {
      shelfCode: 'A-03',
      shelfName: 'A Zone Shelf 3',
      layerCount: 4
    },
    {
      shelfCode: 'B-01',
      shelfName: 'B Zone Shelf 1',
      layerCount: 3
    },
    {
      shelfCode: 'B-02',
      shelfName: 'B Zone Shelf 2',
      layerCount: 4
    }
  ],
  'DG002': [
    {
      shelfCode: 'C-01',
      shelfName: 'C Zone Shelf 1',
      layerCount: 2
    },
    {
      shelfCode: 'C-02',
      shelfName: 'C Zone Shelf 2',
      layerCount: 3
    }
  ],
  'DG003': [],
  'DG004': [
    {
      shelfCode: 'D-01',
      shelfName: 'D Zone Shelf 1',
      layerCount: 4
    },
    {
      shelfCode: 'D-02',
      shelfName: 'D Zone Shelf 2',
      layerCount: 3
    },
    {
      shelfCode: 'D-03',
      shelfName: 'D Zone Shelf 3',
      layerCount: 4
    },
    {
      shelfCode: 'D-04',
      shelfName: 'D Zone Shelf 4',
      layerCount: 3
    }
  ],
  'DG005': [
    {
      shelfCode: 'E-01',
      shelfName: 'E Zone Shelf 1',
      layerCount: 2
    }
  ],
  'DG006': [
    {
      shelfCode: 'F-01',
      shelfName: 'F Zone Shelf 1',
      layerCount: 3
    },
    {
      shelfCode: 'F-02',
      shelfName: 'F Zone Shelf 2',
      layerCount: 3
    }
  ]
};

// Mock Store Display Group data
export const mockStoreDisplayGroups: StoreDisplayGroup[] = [
  {
    storeCode: 'SH001',
    storeName: 'Shanghai Pudong Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Group',
    displayGroupCode: 'HQ_DG001',
    code: 'DG001',
    name: 'Beverage Group',
    subClassSets: [mockSubClasses[0], mockSubClasses[1], mockSubClasses[2]], // Carbonated Drinks, Juice Drinks, Tea Drinks
    shelfSet: mockBoundShelves['DG001'],
    shelfCount: mockBoundShelves['DG001'].length,
    maxSkuCount: 60,
    minSkuCount: 45,
    createTime: '2025-01-01 10:00:00',
    updateTime: '2025-01-27 14:30:00',
    remark: 'Main display area, priority to ensure sufficient shelf space',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-02 15:30:00',
    commercial_approver_account: 'commercial_manager',
    commercial_approver_name: 'Zhang Wei',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-03 09:15:00',
    planogram_approver_account: 'planogram_manager',
    planogram_approver_name: 'Li Ming'
  },
  {
    storeCode: 'SH001',
    storeName: 'Shanghai Pudong Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Group',
    displayGroupCode: 'HQ_DG002',
    code: 'DG002',
    name: 'Snack Group',
    subClassSets: [mockSubClasses[3], mockSubClasses[4], mockSubClasses[5]], // Potato Chips, Biscuits, Chocolate
    shelfSet: mockBoundShelves['DG002'],
    shelfCount: mockBoundShelves['DG002'].length,
    maxSkuCount: 35,
    minSkuCount: 20,
    createTime: '2025-01-02 09:15:00',
    updateTime: '2025-01-26 16:45:00',
    remark: 'Snack display area',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'REJECTED',
    planogram_approver_time: '2025-01-04 14:20:00',
    planogram_approver_account: 'planogram_manager',
    planogram_approver_name: 'Li Ming'
  },
  {
    storeCode: 'SH001',
    storeName: 'Shanghai Pudong Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Group',
    displayGroupCode: 'HQ_DG003',
    code: 'DG003',
    name: 'Personal Care Group',
    subClassSets: [mockSubClasses[6], mockSubClasses[7], mockSubClasses[8]], // Face Masks, Lipstick, Shampoo
    shelfSet: mockBoundShelves['DG003'],
    shelfCount: mockBoundShelves['DG003'].length,
    maxSkuCount: 25,
    minSkuCount: 15,
    createTime: '2025-01-03 14:20:00',
    updateTime: '2025-01-25 11:30:00',
    remark: 'Personal care display area, pending shelf binding',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-04 10:45:00',
    commercial_approver_account: 'commercial_manager',
    commercial_approver_name: 'Zhang Wei',
    planogram_approver_status: 'PENDING',
    planogram_approver_time: undefined,
    planogram_approver_account: undefined,
    planogram_approver_name: undefined
  },
  {
    storeCode: 'SH002',
    storeName: 'Shanghai Xuhui Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Group',
    displayGroupCode: 'HQ_DG001',
    code: 'DG001',
    name: 'Beverage Group',
    subClassSets: [mockSubClasses[0], mockSubClasses[1], mockSubClasses[2]],
    shelfSet: mockBoundShelves['DG004'],
    shelfCount: mockBoundShelves['DG004'].length,
    maxSkuCount: 50,
    minSkuCount: 35,
    createTime: '2025-01-05 08:30:00',
    updateTime: '2025-01-24 13:15:00',
    remark: 'SH002 store beverage display area',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-06 11:20:00',
    commercial_approver_account: 'commercial_supervisor',
    commercial_approver_name: 'Wang Fang',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-07 16:30:00',
    planogram_approver_account: 'planogram_supervisor',
    planogram_approver_name: 'Chen Jun'
  },
  {
    storeCode: 'SH002',
    storeName: 'Shanghai Xuhui Store',
    shopGroupCode: 'SG001',
    shopGroupName: 'Shanghai Group',
    displayGroupCode: 'HQ_DG002',
    code: 'DG002',
    name: 'Snack Group',
    subClassSets: [mockSubClasses[3], mockSubClasses[4], mockSubClasses[5]],
    shelfSet: mockBoundShelves['DG005'],
    shelfCount: mockBoundShelves['DG005'].length,
    maxSkuCount: 30,
    minSkuCount: 18,
    createTime: '2025-01-06 10:45:00',
    updateTime: '2025-01-23 15:20:00',
    remark: 'SH002 store snack display area',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'PENDING',
    planogram_approver_time: undefined,
    planogram_approver_account: undefined,
    planogram_approver_name: undefined
  },
  {
    storeCode: 'SH003',
    storeName: 'Beijing Chaoyang Store',
    shopGroupCode: 'SG002',
    shopGroupName: 'Beijing Group',
    displayGroupCode: 'HQ_DG001',
    code: 'DG001',
    name: 'Beverage Group',
    subClassSets: [mockSubClasses[0], mockSubClasses[1]],
    shelfSet: mockBoundShelves['DG006'],
    shelfCount: mockBoundShelves['DG006'].length,
    maxSkuCount: 40,
    minSkuCount: 25,
    createTime: '2025-01-08 12:00:00',
    updateTime: '2025-01-22 09:45:00',
    remark: 'SH003 store beverage display area, smaller scale',
    commercial_approver_status: 'REJECTED',
    commercial_approver_time: '2025-01-09 13:15:00',
    commercial_approver_account: 'commercial_manager',
    commercial_approver_name: 'Zhang Wei',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-10 08:45:00',
    planogram_approver_account: 'planogram_manager',
    planogram_approver_name: 'Li Ming'
  },
  {
    storeCode: 'SH003',
    storeName: 'Beijing Chaoyang Store',
    shopGroupCode: 'SG002',
    shopGroupName: 'Beijing Group',
    displayGroupCode: 'HQ_DG003',
    code: 'DG003',
    name: 'Personal Care Group',
    subClassSets: [mockSubClasses[6], mockSubClasses[8]],
    shelfSet: [],
    shelfCount: 0,
    maxSkuCount: 20,
    minSkuCount: 12,
    createTime: '2025-01-10 16:30:00',
    updateTime: '2025-01-21 14:10:00',
    remark: 'SH003 store personal care display area, no shelf binding yet',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-11 09:30:00',
    commercial_approver_account: 'commercial_supervisor',
    commercial_approver_name: 'Wang Fang',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-12 14:45:00',
    planogram_approver_account: 'planogram_supervisor',
    planogram_approver_name: 'Chen Jun'
  },
  {
    storeCode: 'SH004',
    storeName: 'Shenzhen Nanshan Store',
    shopGroupCode: 'SG003',
    shopGroupName: 'Shenzhen Group',
    displayGroupCode: 'HQ_DG001',
    code: 'DG001',
    name: 'Beverage Group',
    subClassSets: [mockSubClasses[0], mockSubClasses[1], mockSubClasses[2]],
    shelfSet: [
      {
        shelfCode: 'G-01',
        shelfName: 'G Zone Shelf 1',
        layerCount: 4
      },
      {
        shelfCode: 'G-02',
        shelfName: 'G Zone Shelf 2',
        layerCount: 4
      },
      {
        shelfCode: 'G-03',
        shelfName: 'G Zone Shelf 3',
        layerCount: 3
      },
      {
        shelfCode: 'G-04',
        shelfName: 'G Zone Shelf 4',
        layerCount: 4
      },
      {
        shelfCode: 'G-05',
        shelfName: 'G Zone Shelf 5',
        layerCount: 3
      },
      {
        shelfCode: 'G-06',
        shelfName: 'G Zone Shelf 6',
        layerCount: 4
      }
    ],
    shelfCount: 6,
    maxSkuCount: 80,
    minSkuCount: 60,
    createTime: '2025-01-12 07:45:00',
    updateTime: '2025-01-20 18:25:00',
    remark: 'SH004 store large beverage display area',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-13 10:20:00',
    commercial_approver_account: 'commercial_director',
    commercial_approver_name: 'Liu Gang',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-14 15:40:00',
    planogram_approver_account: 'planogram_director',
    planogram_approver_name: 'Zhao Lei'
  },
  {
    storeCode: 'SH005',
    storeName: 'Guangzhou Tianhe Store',
    shopGroupCode: 'SG004',
    shopGroupName: 'Guangzhou Group',
    displayGroupCode: 'HQ_DG002',
    code: 'DG002',
    name: 'Snack Group',
    subClassSets: [mockSubClasses[3], mockSubClasses[4]],
    shelfSet: [
      {
        shelfCode: 'H-01',
        shelfName: 'H Zone Shelf 1',
        layerCount: 2
      },
      {
        shelfCode: 'H-02',
        shelfName: 'H Zone Shelf 2',
        layerCount: 3
      }
    ],
    shelfCount: 2,
    maxSkuCount: 28,
    minSkuCount: 16,
    createTime: '2025-01-15 11:20:00',
    updateTime: '2025-01-19 13:40:00',
    remark: 'SH005 store snack display area, some shelves pending binding',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-16 12:30:00',
    planogram_approver_account: 'planogram_manager',
    planogram_approver_name: 'Li Ming'
  }
];

// Available store codes
export const mockStoreCodes: string[] = ['SH001', 'SH002', 'SH003', 'SH004', 'SH005'];

// Helper functions
export const getStoreDisplayGroupsByShop = (storeCode: string): StoreDisplayGroup[] => {
  return mockStoreDisplayGroups.filter(group => group.storeCode === storeCode);
};

export const getStoreDisplayGroupByCode = (code: string, storeCode?: string): StoreDisplayGroup | undefined => {
  return mockStoreDisplayGroups.find(group =>
    group.code === code && (!storeCode || group.storeCode === storeCode)
  );
};

export const getBoundShelvesForGroup = (code: string): BoundShelf[] => {
  const group = mockStoreDisplayGroups.find(g => g.code === code);
  return group?.shelfSet || [];
};

export const getStoreCodeOptions = (): { label: string; value: string }[] => {
  return mockStoreCodes.map(code => ({
    label: `${code} - ${getShopDisplayName(code)}`,
    value: code
  }));
};

export const getShopDisplayName = (shopCode: string): string => {
  const shopNames: { [key: string]: string } = {
    'SH001': 'Shanghai Pudong Store',
    'SH002': 'Shanghai Xuhui Store',
    'SH003': 'Beijing Chaoyang Store',
    'SH004': 'Shenzhen Nanshan Store',
    'SH005': 'Guangzhou Tianhe Store'
  };
  return shopNames[shopCode] || shopCode;
};

export const getAllDivisions = (): string[] => {
  return Array.from(new Set(mockSubClasses.map(sc => sc.divisionName)));
};